import { render, staticRenderFns } from "./BookmarkFeatureDescription.vue?vue&type=template&id=6e882b74"
import script from "./BookmarkFeatureDescription.vue?vue&type=script&lang=js"
export * from "./BookmarkFeatureDescription.vue?vue&type=script&lang=js"
import style0 from "./BookmarkFeatureDescription.vue?vue&type=style&index=0&id=6e882b74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports